import React from 'react';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { FaCloudDownloadAlt } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import ImportExportAPI from '../../../api/ImportExportAPI';
import DocumentAPI from '../../../api/DocumentAPI';
import Util from '../../../util/Util';
import withRouter from '../../../util/WithRouter';
import Const from '../../../util/Constants';
import Display from '../../../util/Display';
import ApiUiController from '../../../controller/ApiUiController';

class ExportList extends React.Component {

  constructor(props) {
    super(props);
    this.data = [];
    this.state = { inApiCall: true };
    this.path = this.props.match.path;

    const model = reactLocalStorage.getObject(Const.Model).export;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(model.permission, Const.PermRestricAcc);
  }

  componentDidMount() {
    if (this.List) {
      const filters = [];
      if (this.Restrict) {
        const user = reactLocalStorage.getObject(Const.LoggedInUser);
        user.child.push(user.user_id);
        filters.push({
          field: 'created_by', type: 'multiselect~user',
          condition: 'in', value: `${Const.Opt}${user.child.join(Const.Opt)}${Const.Opt}`
        });
      }
      ImportExportAPI.exportList(filters, this.onReceived, this.onFail);
    }
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = data => { this.data = data.data; this.setState({ inApiCall: false }); };

  confirmDelete = index => {
    Util.confirmAlert('Delete', 'Are you sure you want to delet', 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      ImportExportAPI.exportDelete(this.data[index].id, this.onDelete, this.onFail);
    });
  };
  onDelete = () => {
    Util.showNotification('Successful', 'Export deleted successfully', 'success');
    ImportExportAPI.exportList(this.onReceived, this.onFail);
  };

  downalod = async index => {
    const res = await DocumentAPI.getPublicMediaUrl(this.data[index].file);
    window.open(res.url, '_blank');
  };

  render() {
    if (!this.List) return;

    let uis = this.data.map((element, _i) => (
      <tr key={`export_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{Display.ModulLabelValue(element.module)}</td>
        <td>
          {
            element.export_status === 1 ? 'Not Started' :
              element.export_status === 2 ? 'In Progress' :
                'Successfull'
          }
        </td>
        <td>{Display.ModelLabelValue('user', element.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(element.created_date)}</td>
        <td>{Display.ModelLabelValue('user', element.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(element.updated_date)}</td>
        <td>
          {element.export_status === 3 &&
            <Button className="buttons quote" onClick={() => this.downalod(_i)}>
              <FaCloudDownloadAlt /> Download
            </Button>
          }
          { /*
            <span onClick={() => this.confirmDelete(_i)} className="buttons delete">
              <FaTrash /> Delete
            </span>
          */}
        </td>
      </tr>
    ));

    if (this.data.length === 0) uis = <tr><td colSpan="8">No Records Found</td></tr>;

    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <div className="row">

            <div className="col-md-6 pb-3"> <h3>Exports</h3> </div>

            <div className="col-md-12">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>No</th> <th>Module</th> <th>Status</th> <th>Created By</th>
                    <th>Created Date</th> <th>Updated By</th> <th>Updated Date</th> <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <ApiUiController inApiCall={this.props.inApiCall}>
                    {uis}
                  </ApiUiController>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(ExportList);
